"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NavbarModule {
}
exports.NavbarModule = NavbarModule;
